export default __webpack_public_path__ + "static/media/upload-cloud.718a67ff.svg";